import { render, staticRenderFns } from "./DDJUnExecuteLog.vue?vue&type=template&id=3c8b6e74&scoped=true&"
import script from "./DDJUnExecuteLog.vue?vue&type=script&lang=js&"
export * from "./DDJUnExecuteLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b6e74",
  null
  
)

export default component.exports